const FALLBACK_APPLIED_DATA_ATTR = 'fallbackApplied';
export function replaceBrokenImageSrc(event: Event, fallbackSrc: string) {
  const target = event.target;
  if (!(target instanceof HTMLImageElement) || !fallbackSrc) {
    return;
  }
  if (target.dataset[FALLBACK_APPLIED_DATA_ATTR] === 'true') {
    return;
  }
  target.dataset[FALLBACK_APPLIED_DATA_ATTR] = 'true';
  target.src = fallbackSrc;
}
